import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * 管理员中心侧边栏组件
 *
 * 展示内置的"Dashboard"入口和第三方注册的 slot 入口。
 */
import * as React from 'react';
import { useRoute } from '@hvsin/mod-route';
import { DASHBOARD_SECTION_ID } from '@hvsin/admin-contracts';
import { DashboardIcon, DefaultSlotIcon } from './icons.js';
/**
 * 管理员中心侧边栏
 */
export function Sidebar({ slots }) {
    const { useSearchParams } = useRoute();
    const [searchParams, setSearchParams] = useSearchParams();
    const activeSection = searchParams.get('section') || DASHBOARD_SECTION_ID;
    const handleNavigate = (sectionId) => {
        setSearchParams({ section: sectionId });
    };
    return (_jsxs("aside", { style: styles.sidebar, children: [_jsxs("div", { style: styles.header, children: [_jsx("div", { style: styles.logo, children: "\u2699\uFE0F" }), _jsx("span", { style: styles.headerText, children: "\u7BA1\u7406\u540E\u53F0" })] }), _jsxs("nav", { style: styles.nav, children: [_jsx("p", { style: styles.navTitle, children: "\u7CFB\u7EDF\u7BA1\u7406" }), _jsx(NavItem, { icon: React.createElement(DashboardIcon), label: "\u4EEA\u8868\u76D8", isActive: activeSection === DASHBOARD_SECTION_ID, onClick: () => handleNavigate(DASHBOARD_SECTION_ID) }), slots.length > 0 && (_jsxs(_Fragment, { children: [_jsx("div", { style: styles.divider }), _jsx("p", { style: styles.navTitle, children: "\u6269\u5C55\u529F\u80FD" }), slots.map(slot => (_jsx(NavItem, { icon: slot.icon ? React.createElement(slot.icon) : React.createElement(DefaultSlotIcon), label: slot.label, isActive: activeSection === slot.id, onClick: () => handleNavigate(slot.id) }, slot.id)))] }))] }), _jsx("div", { style: styles.footer, children: _jsx("span", { style: styles.footerText, children: "Admin v1.0" }) })] }));
}
/** 导航条目组件 */
function NavItem({ icon, label, isActive, onClick }) {
    const [hovered, setHovered] = React.useState(false);
    return React.createElement('button', {
        onClick,
        onMouseEnter: () => setHovered(true),
        onMouseLeave: () => setHovered(false),
        style: {
            ...styles.navItem,
            backgroundColor: isActive ? '#334155' : hovered ? '#334155' : 'transparent',
            color: isActive ? '#f1f5f9' : '#cbd5e1',
            fontWeight: isActive ? 600 : 500,
        },
    }, React.createElement('span', { style: { ...styles.navIcon, color: isActive ? '#818cf8' : '#94a3b8' } }, icon), React.createElement('span', { style: styles.navLabel }, label), isActive && React.createElement('span', { style: styles.activeIndicator }));
}
const styles = {
    sidebar: {
        width: '240px',
        minHeight: '100vh',
        backgroundColor: '#1e293b',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        position: 'sticky',
        top: 0,
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '20px 16px',
        borderBottom: '1px solid #334155',
    },
    logo: {
        fontSize: '24px',
    },
    headerText: {
        fontSize: '16px',
        fontWeight: 600,
        color: '#f1f5f9',
    },
    nav: {
        flex: 1,
        padding: '12px 8px',
        overflowY: 'auto',
    },
    navTitle: {
        fontSize: '11px',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        color: '#94a3b8',
        margin: '8px 8px 4px',
        padding: '0 4px',
    },
    navItem: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        width: '100%',
        padding: '10px 12px',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        fontSize: '14px',
        textAlign: 'left',
        transition: 'all 0.15s ease',
        position: 'relative',
    },
    navIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    navLabel: {
        flex: 1,
    },
    activeIndicator: {
        width: '4px',
        height: '20px',
        backgroundColor: '#6366f1',
        borderRadius: '2px',
        position: 'absolute',
        right: 0,
        top: '50%',
        transform: 'translateY(-50%)',
    },
    divider: {
        height: '1px',
        backgroundColor: '#334155',
        margin: '12px 8px',
    },
    footer: {
        padding: '16px',
        borderTop: '1px solid #334155',
        textAlign: 'center',
    },
    footerText: {
        fontSize: '12px',
        color: '#64748b',
    },
};
//# sourceMappingURL=sidebar.js.map